import styled from 'styled-components';

export const Title = styled('div')(() => ({
  width: '30%',
  background: '#1976d2',
  color: 'white',
  textAlign: 'center',
  borderRadius: '5px',
  paddingTop: '8px',
}));

export const Header = styled.h3`
  margin: 12px;
  padding-left: 3px;
`;

export const SelectFileDiv = styled.div`
  flex-grow: 4;
  background-color: rgb(194, 194, 194) !important;

  width: 100%;
  min-width: 300px;

  label {
    font-weight: 500;
    cursor: pointer;
  }
  input {
    width: 96%;
    border-radius: 7px;
    cursor: pointer;
    transition: background-color 0.2s;
    padding: 15px 16px 8px 16px;
    color: #312e38;
    display: inline-block;
    margin: 8px 13px 6px 0;
  }
`;

export const ButtonUpload = styled.div`
  flex-grow: 1;
  border-radius: 7px;
  min-width: 300px;
  cursor: pointer;
  transition: background-color 0.2s;
  padding: 15px 16px 8px 16px;
  color: #312e38;
  display: inline-block;
  width: 130px;
  margin: 8px 13px 6px 8px;

  label {
    font-weight: 500;
    cursor: pointer;

    input {
      display: none;
    }
  }

  &:hover {
    background: rgb(230, 130, 0);
  }
`;

export const FileInput = styled.input`
  background-color: rgb(194, 194, 194) !important;
  color: #000 !important;
  padding: 6px;

  /* botão do input */
  &::file-selector-button {
    background-color: #a8a8a8 !important;

    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    color: #000;
    transition: background-color 0.2s ease-in-out;
  }

  &::file-selector-button:hover {
    background-color: #444242ff;
  }

  /* fallback para navegadores baseados em webkit */
  &::-webkit-file-upload-button {
    background-color: #c2c2c2;
    border: none;
    border-radius: 4px;
    padding: 6px 12px;
    cursor: pointer;
    color: #000;
    transition: background-color 0.2s ease-in-out;
  }

  &::-webkit-file-upload-button:hover {
    background-color: #444242ff;
  }
`;
